export enum SocketSessionError {
  BadRequest = 'Bad Request',
  AccessDenied = 'Access Denied',
  UnableToReachServer = 'Unable To Reach Server',
  UnexpectedError = 'Unexpected Error'
}
